import { render, staticRenderFns } from "./valmistumispyynnon-tila-erikoistuja.vue?vue&type=template&id=a3bab95a&scoped=true&"
import script from "./valmistumispyynnon-tila-erikoistuja.vue?vue&type=script&lang=ts&"
export * from "./valmistumispyynnon-tila-erikoistuja.vue?vue&type=script&lang=ts&"
import style0 from "./valmistumispyynnon-tila-erikoistuja.vue?vue&type=style&index=0&id=a3bab95a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3bab95a",
  null
  
)

export default component.exports